import { useQuery } from "@tanstack/react-query";
import { getInvitations, getReceivedInvitations } from "../actions/getInvitations";
import { gateway } from "src/gateway";

export interface IUseInvitationsParams {
  type?: string;
  page?: number;
  pageSize?: number;
}
interface UseGetReceivedInvitationsParams {
  page?: number;
  pageSize?: number;
}

export const useGetInvitations = (params: IUseInvitationsParams) => {
  return useQuery({
    queryKey: ["invitations", params],
    queryFn: () => getInvitations(params.type, params.page, params.pageSize),
    enabled: !!params, // optional; you can remove this line
  });
};

export const useGetReceivedInvitations = ({ page = 1, pageSize = 50 }: UseGetReceivedInvitationsParams = {}) => {
  return useQuery({
    queryKey: ["received-invitations", page, pageSize],
    queryFn: () => getReceivedInvitations(page, pageSize),
  });
};
